import { ApiService } from 'src/app/api.service';
import { Component, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-menu-mobile',
  templateUrl: './menu-mobile.component.html',
  styleUrls: ['./menu-mobile.component.scss']
})
export class MenuMobileComponent {
  categories: any;
  subCategories: any;
  subSubCategories: any;
  categorySelected: any;
  subCategorieSelected: any;
  isMenuVisible: boolean = false;
  isRepresentanteVisible: boolean = false;
  activeDropdowns: string[] = [];
  subcategorieReports: any[]= []


  private destroy$ = new Subject();

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<MenuMobileComponent>,
    private router: Router,
    private elementRef: ElementRef<HTMLElement>
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.closeMenu();
    });
  }

  private getVisibleMenuItems(selector = '[data-mobile-menu-item]'): HTMLElement[] {
    return Array.from(this.elementRef.nativeElement.querySelectorAll<HTMLElement>(selector))
      .filter((element) => element.offsetParent !== null);
  }

  private focusMenuItem(element?: HTMLElement | null) {
    element?.focus({ preventScroll: true });
  }

  private focusMenuByDelta(current: HTMLElement, delta: number, selector = '[data-mobile-menu-item]') {
    const items = this.getVisibleMenuItems(selector);
    if (!items.length) {
      return;
    }

    const currentIndex = items.indexOf(current);
    const nextIndex = currentIndex === -1 ? 0 : (currentIndex + delta + items.length) % items.length;
    this.focusMenuItem(items[nextIndex]);
  }

  private focusFirstMenuItem(selector = '[data-mobile-menu-item]') {
    const items = this.getVisibleMenuItems(selector);
    this.focusMenuItem(items[0]);
  }

  private focusLastMenuItem(selector = '[data-mobile-menu-item]') {
    const items = this.getVisibleMenuItems(selector);
    this.focusMenuItem(items[items.length - 1]);
  }

  private findMenuToggle(selector: string): HTMLElement | null {
    return this.elementRef.nativeElement.querySelector<HTMLElement>(selector);
  }

  private openCategory(category: any) {
    this.categorySelected = category.id;
    category.categorias.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
    this.subCategories = category.categorias;
    this.subSubCategories = [];
    this.subCategorieSelected = null;
  }

  private closeCategory() {
    this.categorySelected = null;
    this.subCategories = [];
    this.subSubCategories = [];
    this.subCategorieSelected = null;
  }

  private openSubCategory(subCategory: any) {
    this.subCategorieSelected = subCategory.id;
    this.subSubCategories = [];
  }

  private closeSubCategory() {
    this.subCategorieSelected = null;
    this.subSubCategories = [];
  }

  ngOnDestroy() {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }

  async checkHasProducts(subcategorias: any){
    if(!subcategorias) return;
    subcategorias.forEach(async (categoria: any) =>{
      let products = await this.apiService.getCategoriesWithProductsFiltered(categoria.id)
      if(products.length > 0){
        categoria.hasProducts = true;

      } else{
        categoria.hasProducts = false;
      }
    })
    return subcategorias
  }

  toggleDropdown(menu: string) {

    const index = this.activeDropdowns.indexOf(menu);
    if (index !== -1) {

      this.activeDropdowns.splice(index, 1);
    } else {

      this.activeDropdowns.push(menu);
    }
  }

  isDropdownActive(menu: string): boolean {
    return this.activeDropdowns.includes(menu) ;
  }

  isDropdownActiveClass(menu: string): string {
    return this.isDropdownActive(menu) ? 'open' : 'close';
  }

  showMenu() {
    this.isMenuVisible = true;
  }

  showRepresentante() {
    this.isRepresentanteVisible = true;
  }
  showReports() {
    if (this.subcategorieReports.length > 0) {
        this.subcategorieReports = [];
    } else {
      this.subcategorieReports = [
      {nome: 'Metalúrgica 01/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relatorio+Transparencia+Metal.pdf'},
      {nome: 'Metalúrgica 02/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-02-2024-Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 01/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-032025-Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 02/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+082025+-+Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 01/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+032026+-+Metalu%CC%81rgica.pdf'},

      {nome: 'Plástico 01/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/relatorio+Transparecncia+Plasticos.pdf'},
      {nome: 'Plástico 02/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-02-2024-Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 01/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-032025-Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 02/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+082025+-+Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 01/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+032026+-+Plasticos.pdf'}
    ]
    }
  }
  hideReport(){
    this.subcategorieReports = [];
  }

  ngOnInit(): void {
    this.loadCategories();
  }

  loadCategories(){
    this.apiService.loadCategories().then((result => {
      this.categories = result
      this.categories.sort((a: { prioridade: number; nome: string; }, b: { prioridade: number; nome: any; }) => {
      return a.prioridade - b.prioridade || a.nome.localeCompare(b.nome);
      });
    }))
  }

  triggerAccessibilityModal() {
    this.closeMenu();
    window.dispatchEvent(new CustomEvent('open-accessibility-modal'));
  }

  closeMenu(){
    this.dialogRef.close();
  }

  showSubcategory(show: boolean, category: any){
    if(this.categorySelected === category.id){
      show = false
      this.categorySelected = null
    } else {
      this.categorySelected = category.id
    }

    if (show) {
      category.categorias.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
      this.subCategories = category.categorias;
      this.subSubCategories = [];
    } else {
      this.subSubCategories = [];
    }

  }

  async showSubSubcategory(show: boolean, subCategory: any){

    if(this.subCategorieSelected === subCategory.id){
      show = false
      this.subCategorieSelected = null
    } else {
      this.subCategorieSelected = subCategory.id
    }

    if(show){
      this.subSubCategories = await this.checkHasProducts(subCategory.subcategorias);

    } else{
      this.subSubCategories = [];
    }
  }

  onMenuItemKeydown(event: KeyboardEvent) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      event.preventDefault();
      this.focusMenuByDelta(current, 1);
      return;
    }

    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      event.preventDefault();
      this.focusMenuByDelta(current, -1);
      return;
    }

    if (event.key === 'Home') {
      event.preventDefault();
      this.focusFirstMenuItem();
      return;
    }

    if (event.key === 'End') {
      event.preventDefault();
      this.focusLastMenuItem();
    }
  }

  onCategoryToggleKeydown(event: KeyboardEvent, category: any) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.openCategory(category);
      queueMicrotask(() => this.focusFirstMenuItem('[data-subcategory-link]'));
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.closeCategory();
      this.focusMenuItem(this.findMenuToggle(`[data-category-toggle="${category.id}"]`));
      return;
    }

    this.onMenuItemKeydown(event);
  }

  onSubCategoryToggleKeydown(event: KeyboardEvent, subCategory: any) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.openSubCategory(subCategory);
      queueMicrotask(() => this.focusFirstMenuItem('[data-subsubcategory-link]'));
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.closeSubCategory();
      this.focusMenuItem(this.findMenuToggle(`[data-subcategory-toggle="${subCategory.id}"]`));
      return;
    }

    this.onMenuItemKeydown(event);
  }

  onSubCategoryLinkKeydown(event: KeyboardEvent, category: any) {
    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.closeCategory();
      this.focusMenuItem(this.findMenuToggle(`[data-category-toggle="${category.id}"]`));
      return;
    }

    this.onMenuItemKeydown(event);
  }

  onSubSubCategoryLinkKeydown(event: KeyboardEvent, subCategory: any) {
    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.closeSubCategory();
      this.focusMenuItem(this.findMenuToggle(`[data-subcategory-toggle="${subCategory.id}"]`));
      return;
    }

    this.onMenuItemKeydown(event);
  }

  onReportsToggleKeydown(event: KeyboardEvent) {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.showReports();
      queueMicrotask(() => this.focusFirstMenuItem('[data-report-item]'));
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.hideReport();
      this.focusMenuItem(this.findMenuToggle('[data-reports-toggle]'));
      return;
    }

    this.onMenuItemKeydown(event);
  }

  onReportItemKeydown(event: KeyboardEvent) {
    const current = event.currentTarget as HTMLElement | null;
    if (!current) {
      return;
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.focusMenuByDelta(current, 1, '[data-report-item]');
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.focusMenuByDelta(current, -1, '[data-report-item]');
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Escape') {
      event.preventDefault();
      this.hideReport();
      this.focusMenuItem(this.findMenuToggle('[data-reports-toggle]'));
    }
  }

}
